module.exports = __webpack_public_path__ + "media/images/flags/4x3/est-65f4a3d8a979c3ca5a96b32404d2010e.svg";